import styled from 'styled-components';

export const DuplicatesContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DuplicatesGraph = styled.div`
  display: flex;
  transform: translateY(50%);
  flex-grow: 1;
  min-width: 8rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-width: 12rem;
  }

  & > div.content {
    display: flex;
    width: 100%;
    animation: width 1.25s ease-in-out;

    @keyframes width {
      0% {
        width: 0%;
      }
      100% {
        width: 100%;
      }
    }

    & > div {
      height: 2.2rem;

      &.due {
        background-color: ${({ theme }) => theme.colors.orange2};
      }

      &.open {
        background-color: ${({ theme }) => theme.colors.blue3};
      }
    }
  }
`;

export const DuplicatesLegend = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 4.5rem;
  max-width: 7.5rem;
  flex-grow: 1;

  & > div.legend-container {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    display: flex;
    align-items: center;

    & > span.ball {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      margin-right: 0.25rem;

      &.open {
        background-color: ${({ theme }) => theme.colors.blue3};
      }

      &.due {
        background-color: ${({ theme }) => theme.colors.orange2};
      }
    }
  }

  & > div.value {
    height: 4rem;
    display: flex;
    align-items: center;
    margin-top: 0.875rem;

    &.open {
      border-right: 1px solid ${({ theme }) => theme.colors.grayAntdBorder};
      padding-right: 0.5rem;
    }

    &.due {
      border-left: 1px solid ${({ theme }) => theme.colors.grayAntdBorder};
      padding-left: 0.5rem;
    }

    & > span {
      font-size: 0.75rem;
      font-weight: 700;
    }
  }
`;

export const DuplicatesFooter = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  margin: auto;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-size: 0.875rem;
  text-align: end;

  & > span:last-child {
    font-weight: 700;
    margin-left: 0.25rem;
  }
`;
